import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from "./base.sevice";

@Injectable()
export class WalletService extends BaseService {

    url = `${environment.apiBaseUrl}/consumers`;

    constructor(private http: HttpClient) {
        super();
    }

    balance(consumerId: string) {
        return this.http.get(`${this.url}/${consumerId}/wallets/balance`);
    }
}